// extracted by mini-css-extract-plugin
module.exports = {"rateDetailItemList":"RateDetailItemList_rateDetailItemList__1SFHj","rateDetailItem":"RateDetailItemList_rateDetailItem__2e74Y"};